var $ = Object.defineProperty;
var g = Object.getOwnPropertySymbols;
var P = Object.prototype.hasOwnProperty, _ = Object.prototype.propertyIsEnumerable;
var h = (r, e, t) => e in r ? $(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, w = (r, e) => {
  for (var t in e || (e = {}))
    P.call(e, t) && h(r, t, e[t]);
  if (g)
    for (var t of g(e))
      _.call(e, t) && h(r, t, e[t]);
  return r;
};
var u = (r, e, t) => (h(r, typeof e != "symbol" ? e + "" : e, t), t);
var d = (r, e, t) => new Promise((o, i) => {
  var l = (s) => {
    try {
      p(t.next(s));
    } catch (n) {
      i(n);
    }
  }, b = (s) => {
    try {
      p(t.throw(s));
    } catch (n) {
      i(n);
    }
  }, p = (s) => s.done ? o(s.value) : Promise.resolve(s.value).then(l, b);
  p((t = t.apply(r, e)).next());
});
import { browserEnv as q, mapApi as f, LocaleType as y } from "@bilibili-intl/utils";
class L extends Error {
  constructor(t, o) {
    super();
    u(this, "code");
    u(this, "message");
    this.code = t, this.message = o;
  }
}
const O = (r) => {
  const { locale: e, platform: t } = r, o = `${q.inBrowser ? f(location.href).api : "//api.bilibili.tv"}/x/intl_vip/web/pay/`, i = (s, n) => d(void 0, null, function* () {
    const c = yield fetch(`${o}${s}`, n), { code: a, message: m, data: v } = yield c.json();
    if (a !== 0)
      throw new L(a, m);
    return v;
  });
  return { get: (s, n) => {
    var a;
    const c = new URLSearchParams(w({ s_locale: (a = y.get(e)) != null ? a : "en", platform: t }, n));
    return i(`${s}?${c.toString()}`, {
      credentials: "include"
    });
  }, post: (s, n) => {
    var a;
    const c = new URLSearchParams({ s_locale: (a = y.get(e)) != null ? a : "en", platform: t });
    return i(`${s}?${c.toString()}`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(n != null ? n : {})
    });
  }, postForm: (s, n) => {
    var a;
    const c = new URLSearchParams({ s_locale: (a = y.get(e)) != null ? a : "en", platform: t });
    return i(`${s}?${c.toString()}`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(n != null ? n : {})
    });
  } };
}, C = (r) => {
  const e = O(r);
  return {
    queryChannelList: (t) => e.get("channel_list", t),
    createOrder: (t) => e.post("pay", t)
  };
};
class x {
  constructor(e) {
    u(this, "api");
    this.config = e, this.init(e);
  }
  init(e) {
    this.setConfig(e);
  }
  setConfig(e) {
    this.config = e, this.api = C(this.config);
  }
  /**
   * @desc 创建支付订单
   * @param params CreateOrderParams
   * @returns Promise<CreateOrderRes>
   */
  createOrder(e) {
    return d(this, null, function* () {
      return this.api.createOrder(e);
    });
  }
  /**
   * @desc 根据商品code获取对应code的列表信息
   * @param params { product_codes: string[]; customer_id: string }
   * @returns Promise<ProductDetail>
   */
  queryProductDetailBy(e) {
    return d(this, null, function* () {
      const { product_codes: t, customer_id: o } = e;
      try {
        const { channel_list: i } = yield this.api.queryChannelList({
          product_codes: t.join(","),
          customer_id: o
        });
        return i;
      } catch (i) {
        return [];
      }
    });
  }
}
var R = /* @__PURE__ */ ((r) => (r.Video = "bstar-web.pgc-video-detail.episode.0", r.Quality = "bstar-web.pgc-video-detail.switch-quality.0", r.PayTip = "bstar-web.pgc-video-detail.premium-btn.all", r.Callback = "bstar-web.vip-order.confirm.repay", r.Benefits = "bstar-web.vip-benefits.premium-btn.all", r.UgcAd = "bstar-web.ugc-video-detail.player.skip-ads", r.OgvAd = "bstar-web.pgc-video-detail.player.skip-ads", r))(R || {});
function T(r, e, t) {
  const o = new URL(`${f(location.href).domain}/vip/${e}/${r}`);
  return Object.entries(t).forEach(([i, l]) => {
    o.searchParams.set(i, l);
  }), o.toString();
}
function A(r, e) {
  const t = window.open("", "_blank");
  setTimeout(() => {
    try {
      t && (t.location = T("purchase", e, {
        order_source: r
      }));
    } catch (o) {
      t == null || t.close();
    }
  }, 0);
}
export {
  R as SpmId,
  x as default,
  A as openVip,
  T as resolveVipRoute
};
//# sourceMappingURL=index.es.js.map
